import { useEffect, useRef, useState } from 'react';

// ~300ms highlight when the guest switches persona, so the tailored content
// visibly answers the toggle. Skipped on first render. The lead's live region
// is what tells screen-reader and reduced-motion users; this is the sighted cue.
export function usePersonaPulse(personaKey) {
  const [pulse, setPulse] = useState(false);
  const firstRender = useRef(true);
  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
      return;
    }
    setPulse(true);
    const t = setTimeout(() => setPulse(false), 320);
    return () => clearTimeout(t);
  }, [personaKey]);
  return pulse;
}
